import MainPage from "./mainStack/mainPage/MainPage";
import MyCardView from "./mainStack/myCardStack/MyCardView";
import ProfileView from "./mainStack/profileStack/ProfileView";
import TransactionsView from "./mainStack/transactionsStack/TransactionsView";
import LoginView from "./loginStack/LoginView/LoginView";
import RegisterView from "./loginStack/RegisterView/RegisterView";
import ForgotPasswordView from "./loginStack/ForgotPasswordView/ForgotPasswordView";
import EmailVerificationView from "./loginStack/External/EmailVerificationView";
import ChangePasswordView from "./loginStack/External/ChangePasswordView";
import RewardsView from "./mainStack/rewardsStack/rewardsMainPage.js";
import ForgotPasswordMobile from "./loginStack/ForgotPasswordView/ForgotPasswordMobile.js";

import GoogleLoginLogic from "../socialMediaLoginComponents/GoogleLoginLogic";
import MessagesView from "./mainStack/messagesStack/MessagesView.js";

const routes = [
  {
    name: "mainPage",
    title: "mainPage",
    component: MainPage,
    path: "/",
  },
  {
    name: "profilePage",
    title: "profilePage",
    component: ProfileView,
    path: "/profilePage",
  },
  {
    name: "myCardPage",
    title: "myCardPage",
    component: MyCardView,
    path: "/myCardPage",
  },
  {
    name: "rewardsPage",
    title: "myRewards",
    component: RewardsView,
    path: "/myRewards",
  },
  {
    name: "transactionsPage",
    title: "transactionsPage",
    component: TransactionsView,
    path: "/transactionsPage",
  },
];

export const loginRoutes = [
  {
    name: "loginView",
    title: "logIn",
    component: LoginView,
    path: "/",
    autoRelogin: true,
  },

  {
    name: "registerView",
    title: "register",
    component: RegisterView,
    path: "/register",
    autoRelogin: true,
  },

  {
    name: "forgotPasswordView",
    title: null,
    component: ForgotPasswordView,
    path: "/forgotPassword",
    autoRelogin: true,
  },

  {
    name: "EmailVerificationView",
    title: "emailVerification",
    component: EmailVerificationView,
    path: "/emailVerification",
    autoRelogin: true,
  },

  {
    name: "ChangePasswordView",
    title: null,
    component: ChangePasswordView,
    path: "/changePassword",
    autoRelogin: true,
  },
  {
    name: "ForgotPasswordMobile",
    title: null,
    component: ForgotPasswordMobile,
    path: "/forgotPasswordMobile",
    autoRelogin: true,
  },
  {
    name: "socialNetworkOauth",
    title: null,
    component: GoogleLoginLogic,
    path: "/socialNetworkOauth",
    autoRelogin: false,
  },
];

export default routes;
